<template>
    <template v-if="!appData.isMobile">
        <LeftSidebarLayout :type="leftSidebar" />
        <HeaderLayout />
        <main class="main-area">
            <RightSidebarLayout v-if="rightSidebar" />
           <div class="main-content scrollbar-sidebar" :class="[rightSidebar ? 'right' : '' ]">
                <div class="col-12">
                    <slot></slot>
                </div>
           </div>            
        </main>
    </template>
    <template v-else>
        <HeaderLayout>
            <RightSidebarLayout v-if="rightSidebar" />
        </HeaderLayout>
       <div class="content main-content">
            <slot></slot>
       </div>
        <LeftSidebarLayout :type="leftSidebar" />
    </template>
</template>
<script>
    import { Enums } from "@/helpers/enums";
    
    import HeaderLayout from "./HeaderLayout.vue";
    import LeftSidebarLayout from "./LeftSidebarLayout.vue";
    import RightSidebarLayout from "./RightSidebarLayout.vue";
    export default {
        props: { 
            leftSidebar: { 
                type: Number, 
                default: 0 
            }, 
            rightSidebar : {
                type: Boolean, 
                default: false 
            }
        },
        components: {
            HeaderLayout,
            LeftSidebarLayout,
            RightSidebarLayout
        },
    };
</script>